var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-device-selector.ts
import "@adornis/base/utilTypes.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/popover/x-dropdown-search-selection.js";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { property } from "lit/decorators/property.js";
import { state } from "lit/decorators/state.js";
var LocalDeviceSelector = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.value = "";
    this.kind = "any";
  }
  connectedCallback() {
    super.connectedCallback();
    void navigator.mediaDevices.enumerateDevices().then((devices) => this._devices = devices);
  }
  render() {
    return html`
      <x-dropdown-search-selection
        ${injectAttributesOf(this)}
        .debounceInput=${300}
        .value=${this._devices?.find((device) => device.deviceId === this.value && device.kind === this.kind)}
        .search=${async (search) => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const uniqueIDs = /* @__PURE__ */ new Set();
      const exactIncluded = devices.find((d) => d.label.toLocaleLowerCase() === search.toLocaleLowerCase());
      return devices.filter((device) => {
        if (uniqueIDs.has(device.groupId))
          return false;
        if ((this.kind === "any" || device.kind === this.kind) && (exactIncluded || device.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()))) {
          uniqueIDs.add(device.groupId);
          return true;
        }
        return false;
      });
    }}
        .renderItem=${(item) => {
      const icon = item.deviceId === "default" ? html` <x-icon> home </x-icon> ` : item.deviceId === "communications" ? html` <x-icon> call </x-icon> ` : nothing;
      return html`
            <x-flex
              horizontal
              crossaxis-center
              space="sm"
              ${css({ padding: `${this.spacing.sm} ${this.spacing.md}`, cursor: "pointer" })}
            >
              ${icon} <x-text> ${item.label} </x-text>
            </x-flex>
          `;
    }}
        .renderString=${(item) => item?.label}
        @value-picked=${(e) => {
      this.value = e.detail.value?.deviceId ?? "";
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value } }));
    }}
      ></x-dropdown-search-selection>
    `;
  }
};
__decorateClass([
  property()
], LocalDeviceSelector.prototype, "value", 2);
__decorateClass([
  property()
], LocalDeviceSelector.prototype, "kind", 2);
__decorateClass([
  state()
], LocalDeviceSelector.prototype, "_devices", 2);
LocalDeviceSelector = __decorateClass([
  customElement("x-device-selector")
], LocalDeviceSelector);
export {
  LocalDeviceSelector
};
